export const SET_VERSION = 'setVersion'
export const SET_MAINTENANCE_MODE = 'setMaintenanceMode'
